module.exports = __webpack_public_path__ + "img/VetoSans-Light_1.07d8a71e.svg";